import { render, staticRenderFns } from "./InvoiceSettings.vue?vue&type=template&id=1371e9c4&scoped=true&"
import script from "./InvoiceSettings.vue?vue&type=script&lang=js&"
export * from "./InvoiceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1371e9c4",
  null
  
)

export default component.exports